import { useState, useEffect, useCallback, useRef } from 'react';

import './Textbausteine.css';
import '../App.css';
import { Link } from 'react-router-dom';
import Header from '../component/Header';
import Footer from '../component/Footer';
import NachObenButton from '../component/NachObenButton';

import { TextbausteineProps, TextbausteineRow } from '../interfaces';
import BackendProvider from '../context/BackendContext';

function Textbausteine() {
  // const stableSetTextblocks = useRef<Function>(setTextblocks);
  const [textblocks, setTextblocks] = useState<Array<TextbausteineRow>>([]);

  const changeViewCallback = useCallback((newView:string) => {
    // changeView(newView);
  }, []);

  const loadData = useCallback(() => {
    const url = '/webclient/php/textbausteine.php';
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Anfrage fehlgeschlagen');
        }
        return res.json();
      })
      .then((data) => {
        setTextblocks(data);
        console.log(data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  function handleSubmit(event:React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const url = '/webclient/php/update_textblocks.php';

    const form = new FormData(document.getElementById('updateTextblocks') as HTMLFormElement ?? undefined);

    fetch(url, { method: 'POST', body: form })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Anfrage fehlgeschlagen');
        }
        // return res.json();
      })
      .then(() => {
        loadData();
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  useEffect(() => {
    loadData();
  }, []);

  const lastInput = useRef({ name: '', value: '' });

  function handleChangeInput({ target }:React.ChangeEvent<HTMLTextAreaElement>) {
    const { name, value } = target;
    
    if (lastInput.current.name !== name) {
      lastInput.current.name = name;
      lastInput.current.value = getFieldValue(name);
    }
 
    setTextblocks(textblocks.map((row:TextbausteineRow) => {
      if (row.txb_id.toString() === name) {
        return { ...row, txbText: value };
      }

      return row;
    }));
  }

  function getFieldValue(fieldName:string) {
    const field = textblocks.find((f) => f.txb_id.toString() === fieldName);

    if (field !== undefined) {
      return field.txbText;
    }

    return '';
  }

  function undo() {
    setTextblocks(textblocks.map((row:TextbausteineRow) => {
      if (row.txb_id.toString() === lastInput.current.name) {
        return { ...row, txbText: lastInput.current.value };
      }

      return row;
    }));
  }

  return (
    <>
      {/* <BackendProvider><Header /></BackendProvider> */}
      <Header />
      <div className="textbausteine-header">
        <h1>Textbausteine</h1>
        <div role="toolbar" aria-label="Menüleiste" className="toolbar">
          <div className="textbausteine-tools">
            <div className="ve-ansicht">
              <h2>Ansicht</h2>
              <div className="">
                <button type="button" className="cancel-button" onClick={undo} title="Änderung im letzten bearbeiteten Feld rückgängig machen">
                  Schritt zurück
                  {/* <img src={cancel} width="" height="" alt="" /> */}
                </button>
              </div>
            </div>
            <div className="ve-ansicht">
              <h2>Optionen</h2>
              <div className="ve-ansicht-buttons">
                <button type="submit" form="updateTextblocks" className="textbausteine-submit">Speichern</button>
              </div>
            </div>
          </div>
          <div className="ve-ansicht">
            <h2>Navigation</h2>
            <div className="textbausteine-navigation">
              <Link to="/bestandsregie" className="button-as-link next-icon" data-text="zurück zur Bestandsregie">zurück zur Bestandsregie</Link>
              {/*
              <button 
                type="button" 
                className="button-as-link next-icon" 
                data-text="zurück zur Bestandsregie" 
                onClick={() => changeView('Bestandsregie')}
              >
                zurück zur Bestandsregie
              </button>
              */}
            </div>
          </div>
        </div>
      </div>
      <div className="textbausteine"> 
        <form aria-label="Textbausteine Formular" id="updateTextblocks" className="textbausteine-form" onSubmit={handleSubmit}>
          {textblocks.map((row:TextbausteineRow, index:number) => (
            <div key={row.txb_id}>
              <div className="textbausteine-label">
                <label htmlFor={'' + row.txb_id}>ALT + {index === 9 ? 0 : index + 1}</label>
              </div>
              <div className="textbausteine-input">
                <textarea maxLength={255} name={'' + row.txb_id} value={row.txbText} onChange={handleChangeInput} /> 
              </div>
            </div>
          ))} 
        </form>

        {/* 
        <form id="updateTextblocks" onSubmit={handleSubmit}>
          {textblocks.map((row:TextbausteineRow, index:number) => (
            <div className="textbausteine-row">
              <div className="textbausteine-label">
                <label htmlFor={'' + row.txb_id}>ALT + {index === 9 ? 0 : index + 1}</label>
              </div>
              <div className="textbausteine-input">
                <textarea rows={2} maxLength={255} name={'' + row.txb_id} value={row.txbText} onChange={handleChangeInput} /> 
              </div>
            </div>
          ))} 
          <div className="textbausteine-row">
            <button type="submit" className="textbausteine-submit">Speichern<img src={save} alt="" /></button>
          </div>
        </form>
        */}
      </div>
      <NachObenButton />
      <Footer />
    </>
  );
}

export default Textbausteine;
